import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { fuelKindField } from './common/fuelFields';
import { ghgCategoryField } from './common/sharedFields';
import { msg } from '@lingui/core/macro';
import { buildingDisplayNameField } from './common/buildingCommonFields';

export const historicalEmissionsMetadata = {
  displayName: msg({
    message: 'Historical emissions',
    context: 'Activity data schema name for historical emissions',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ghg_category_id: ghgCategoryField,
    building_display_name: buildingDisplayNameField,
    energy_kind: {
      displayName: msg({
        message: 'Energy kind',
        context: 'The display name for energy_kind field',
      }),
      externalDescription: msg({
        message:
          'The primary form by which energy was carried. (eg. electricity, heat, steam, etc.)',
        context: 'Energy kind',
      }),
    },
    fuel_kind: fuelKindField,
    is_cogeneration: {
      displayName: msg({
        message: 'Is co-generation',
        context: 'The display name for is_cogeneration field',
      }),
    },
    is_renewable: {
      displayName: msg({
        message: 'Is renewable',
        context: 'The display name for is_renewable field',
      }),
    },
    location_quantity_kg_co2e: {
      displayName: msg({
        message: 'Emissions: location-based',
        context: 'The display name for location_quantity_kg_co2e field',
      }),
    },
    measured_quantity: {
      displayName: msg({
        message: 'Measured quantity',
        context: 'The display name for measured_quantity field',
      }),
      externalDescription: msg({
        message:
          'The quantity of activity or spend data used to calculate the corresponding emissions.',
        context: 'Measured quantity',
      }),
    },
    measured_unit: {
      displayName: msg({
        message: 'Measured activity unit',
        context: 'The display name for measured activity unit field',
      }),
      externalDescription: msg({
        message:
          'The unit of activity or spend data used to calculate the corresponding emissions.',
        context: 'Measured activity unit',
      }),
    },
    quantity_kg_co2e: {
      displayName: msg({
        message: 'Emissions: market-based',
        context: 'The display name for quantity_kg_co2e field',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
